(function () {
  function moneyFromVariant(variant) {
    if (!variant || typeof variant.price !== 'number') return '';
    if (window.Shopify && Shopify.formatMoney) {
      var format = (window.theme && window.theme.moneyFormat) || window.moneyFormat;
      return Shopify.formatMoney(variant.price, format);
    }
    return '';
  }

  function optionGroups(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown'));
  }

  function groupSelected(group) {
    if (group.matches('fieldset')) return !!group.querySelector('input[type="radio"]:checked');
    var select = group.querySelector('select');
    return !!(select && select.value && select.value !== 'Default Title');
  }

  function selectedVariantSummary(scope) {
    var parts = [];
    var color = scope.querySelector('[data-apella-current-color]');
    if (color && color.textContent.trim()) parts.push(color.textContent.trim());
    optionGroups(scope).forEach(function (group) {
      if (group.dataset.apellaTouched !== 'true') return;
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      var value = checked ? checked.value : select && select.value;
      if (value && value !== 'Default Title') parts.push(value);
    });
    return parts.filter(function (value, index, array) { return array.indexOf(value) === index; }).join(' / ');
  }

  function nativeButtons(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('.product-form__submit, .shopify-payment-button__button'));
  }

  function containsBuyingButtonChange(mutations) {
    var selector = '.product-form__submit, .shopify-payment-button__button';
    return Array.prototype.some.call(mutations || [], function (mutation) {
      if (mutation.type === 'attributes') {
        return !!(mutation.target && mutation.target.matches && mutation.target.matches(selector));
      }
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        if (!node || node.nodeType !== 1) return false;
        return (node.matches && node.matches(selector)) || (node.querySelector && node.querySelector(selector));
      });
    });
  }

  function containsVariantControlChange(mutations) {
    var selector = 'variant-selects, fieldset.product-form__input, .product-form__input--dropdown';
    return Array.prototype.some.call(mutations || [], function (mutation) {
      if (mutation.type === 'childList' && mutation.target && mutation.target.closest && mutation.target.closest('variant-selects')) return true;
      var changedNodes = Array.prototype.slice.call(mutation.addedNodes || []).concat(Array.prototype.slice.call(mutation.removedNodes || []));
      return changedNodes.some(function (node) {
        if (!node || node.nodeType !== 1) return false;
        return (node.matches && node.matches(selector)) || (node.querySelector && node.querySelector(selector));
      });
    });
  }

  function syncTouchedGroups(groups, touched) {
    Array.prototype.forEach.call(groups || [], function (group, index) {
      group.dataset.apellaOptionIndex = String(index);
      group.dataset.apellaTouched = touched.has(index) ? 'true' : 'false';
    });
  }

  function markGroupTouched(group, groups, touched) {
    if (!group) return false;
    var storedIndex = group.dataset.apellaOptionIndex;
    var index = storedIndex === undefined ? Array.prototype.indexOf.call(groups, group) : Number(storedIndex);
    if (Number.isNaN(index) || index < 0) return false;
    touched.add(index);
    syncTouchedGroups(groups, touched);
    return true;
  }

  function optionGroupFromClickTarget(target) {
    if (!target || !target.closest) return null;
    var choice = target.closest('label, input[type="radio"]');
    return choice ? target.closest('variant-selects fieldset') : null;
  }

  window.ApellaPdpBuyingStateModel = {
    containsBuyingButtonChange: containsBuyingButtonChange,
    containsVariantControlChange: containsVariantControlChange,
    syncTouchedGroups: syncTouchedGroups,
    markGroupTouched: markGroupTouched,
    optionGroupFromClickTarget: optionGroupFromClickTarget
  };

  function allOptionsSelected(scope) {
    var groups = optionGroups(scope);
    if (!groups.length) return true;
    return groups.every(function (group) {
      return group.dataset.apellaTouched === 'true' && groupSelected(group);
    });
  }

  function firstMissingOptionGroup(scope) {
    return optionGroups(scope).find(function (group) {
      return !groupSelected(group) || group.dataset.apellaTouched !== 'true';
    });
  }

  function wiggleMissingOptions(scope) {
    optionGroups(scope).filter(function (group) {
      return !groupSelected(group) || group.dataset.apellaTouched !== 'true';
    }).forEach(function (group) {
      group.classList.remove('apella-option-wiggle');
      void group.offsetWidth;
      group.classList.add('apella-option-wiggle');
      window.setTimeout(function () { group.classList.remove('apella-option-wiggle'); }, 520);
    });
  }

  function scrollToMissingOption(scope) {
    wiggleMissingOptions(scope);
    var group = firstMissingOptionGroup(scope) || scope.querySelector('variant-selects');
    if (!group) return;
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var target = group.querySelector('input[type="radio"] + label') || group.querySelector('select') || group;
    window.setTimeout(function () {
      if (target && target.focus) target.focus({ preventScroll: true });
    }, 420);
  }

  function setBuyingDisabled(scope, disabled) {
    var warning = scope.querySelector('[data-apella-variant-warning]');
    scope.classList.toggle('apella-buying-disabled', disabled);
    // Shopify disables its accelerated checkout element before options are chosen.
    // Catch the shopper's intent above it without enabling the checkout control.
    scope.querySelectorAll('.shopify-payment-button').forEach(function (payment) {
      var guard = payment.querySelector('[data-apella-buy-now-guard]');
      if (!guard && disabled) {
        guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'apella-buy-now-guard';
        guard.dataset.apellaBuyNowGuard = 'true';
        guard.setAttribute('aria-label', payment.querySelector('button')?.textContent.trim() || 'Buy it now');
        payment.appendChild(guard);
      }
      if (guard) guard.hidden = !disabled;
    });
    nativeButtons(scope).forEach(function (button) {
      if (disabled) {
        button.dataset.apellaSelectionBlocked = 'true';
        button.setAttribute('aria-disabled', 'true');
      } else {
        delete button.dataset.apellaSelectionBlocked;
        if (button.disabled) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      }
    });
    if (warning) warning.classList.toggle('is-visible', disabled);
  }

  function initStickyAtc(scope) {
    var sticky = scope.querySelector('[data-apella-sticky-atc]');
    if (!sticky || sticky.dataset.apellaReady === 'true') return;
    sticky.dataset.apellaReady = 'true';

    var formId = sticky.getAttribute('data-product-form-id');
    var form = document.getElementById(formId);
    if (!form) return;

    var submitBtn = sticky.querySelector('[data-apella-sticky-submit]');
    var submitLabel = sticky.querySelector('[data-apella-sticky-label]');
    var submitSpinner = sticky.querySelector('.loading__spinner');
    var priceNode = sticky.querySelector('[data-apella-sticky-price]');
    var variantNode = sticky.querySelector('[data-apella-sticky-variant]');
    var addLabel = sticky.getAttribute('data-label-add') || 'Add to cart';
    var selectLabel = sticky.getAttribute('data-label-select') || 'Select options';
    var oosLabel = sticky.getAttribute('data-label-oos') || 'Sold out';
    var nativeSubmit = form.querySelector('[name="add"]');
    var observeTarget = scope.querySelector('.product-form__buttons') || form;

    function syncFromDom() {
      var summary = selectedVariantSummary(scope);
      if (variantNode) variantNode.textContent = summary || selectLabel;
      if (nativeSubmit && submitBtn) {
        var loading = nativeSubmit.classList.contains('loading');
        var disabled = nativeSubmit.disabled || nativeSubmit.getAttribute('aria-disabled') === 'true';
        var complete = allOptionsSelected(scope);
        submitBtn.disabled = loading || (disabled && complete);
        submitBtn.classList.toggle('loading', loading);
        submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
        if (submitSpinner) submitSpinner.classList.toggle('hidden', !loading);
        submitBtn.setAttribute('aria-disabled', loading || disabled ? 'true' : 'false');
        submitBtn.dataset.apellaSelectOptions = !loading && disabled && !complete ? 'true' : 'false';
        if (submitLabel) submitLabel.textContent = loading ? addLabel : disabled ? (complete ? (nativeSubmit.textContent.trim() || oosLabel) : selectLabel) : addLabel;
      }
    }

    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.matchMedia('(min-width: 990px)').matches) return setVisible(false);
          setVisible(!entry.isIntersecting);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -12% 0px' });
      observer.observe(observeTarget);
    } else {
      window.addEventListener('scroll', function () {
        if (window.matchMedia('(min-width: 990px)').matches) return setVisible(false);
        setVisible(observeTarget.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    if (submitBtn && nativeSubmit) submitBtn.addEventListener('click', function () {
      if (!allOptionsSelected(scope)) {
        scrollToMissingOption(scope);
        return;
      }
      nativeSubmit.click();
      syncFromDom();
    });

    // Mirror the native request lifecycle, including failed requests and retries.
    if (nativeSubmit && window.MutationObserver) {
      var loadingObserver = new MutationObserver(syncFromDom);
      loadingObserver.observe(nativeSubmit, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var price = moneyFromVariant(variant);
        if (priceNode && price) priceNode.innerHTML = price;
        window.setTimeout(syncFromDom, 40);
      });
    }

    scope.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects')) window.setTimeout(syncFromDom, 80);
    });
    scope.addEventListener('apella:variant-state', syncFromDom);

    syncFromDom();
  }

  function initRequiredVariants(scope) {
    if (scope.dataset.apellaVariantsRequired === 'true') return;
    if (scope.dataset.apellaRequireVariants === 'false') return;
    scope.dataset.apellaVariantsRequired = 'true';

    var touched = new Set();
    var warning = scope.querySelector('[data-apella-variant-warning]');
    if (!warning) {
      warning = document.createElement('p');
      warning.className = 'apella-pdp__variant-warning';
      warning.dataset.apellaVariantWarning = 'true';
      warning.textContent = 'Please select all options before adding to cart.';
      var buttons = scope.querySelector('.product-form__buttons');
      if (buttons) buttons.before(warning);
    }

    function refreshGroups() {
      syncTouchedGroups(optionGroups(scope), touched);
    }

    function syncDisabled() {
      refreshGroups();
      setBuyingDisabled(scope, !allOptionsSelected(scope));
      scope.dispatchEvent(new CustomEvent('apella:variant-state', { bubbles: true }));
    }

    refreshGroups();
    setBuyingDisabled(scope, !allOptionsSelected(scope));

    scope.addEventListener('click', function (event) {
      var optionGroup = optionGroupFromClickTarget(event.target);
      if (optionGroup) {
        if (markGroupTouched(optionGroup, optionGroups(scope), touched)) {
          window.requestAnimationFrame ? window.requestAnimationFrame(syncDisabled) : window.setTimeout(syncDisabled, 40);
        }
        return;
      }
      var blockedButton = event.target.closest('.product-form__submit, .shopify-payment-button__button, .shopify-payment-button, [data-apella-buy-now-guard]');
      if (!blockedButton || allOptionsSelected(scope)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      syncDisabled();
      scrollToMissingOption(scope);
    }, true);

    scope.addEventListener('apella:show-missing-options', function () {
      syncDisabled();
      scrollToMissingOption(scope);
    });

    scope.addEventListener('change', function (event) {
      var group = event.target.closest('variant-selects fieldset, variant-selects .product-form__input--dropdown');
      if (!group) return;
      markGroupTouched(group, optionGroups(scope), touched);
      window.requestAnimationFrame ? window.requestAnimationFrame(syncDisabled) : window.setTimeout(syncDisabled, 40);
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId !== scope.dataset.section) return;
        syncDisabled();
      });
    }

    if (window.MutationObserver) {
      var buyingButtonObserver = new window.MutationObserver(function (mutations) {
        if (!containsBuyingButtonChange(mutations) && !containsVariantControlChange(mutations)) return;
        syncDisabled();
      });
      buyingButtonObserver.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }

    var form = scope.querySelector('product-form form');
    if (form) {
      form.addEventListener('submit', function (event) {
        if (allOptionsSelected(scope)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        syncDisabled();
        scrollToMissingOption(scope);

      }, true);
    }
  }


  function initDetailAccordions(scope) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    scope.querySelectorAll('.apella-pdp-detail').forEach(function (details) {
      if (details.dataset.apellaAccordionReady === 'true') return;
      details.dataset.apellaAccordionReady = 'true';
      var summary = details.querySelector('summary');
      if (!summary) return;
      details.removeAttribute('name');
      function closeOthers() {
        details.closest('.apella-pdp-details').querySelectorAll('.apella-pdp-detail').forEach(function (other) {
          if (other === details || !other.open || other.classList.contains('is-closing')) return;
          if (other._apellaSetAccordionOpen) other._apellaSetAccordionOpen(false);
        });
      }
      details.addEventListener('toggle', function () {
        if (details.open && !details.classList.contains('is-closing')) closeOthers();
        else if (!details.open && details._apellaAccordionAnimation) details._apellaAccordionAnimation.cancel();
      });
      function setOpen(opening) {
        var activeAnimation = details._apellaAccordionAnimation;
        if (opening) closeOthers();
        if (reducedMotion.matches || typeof details.animate !== 'function') {
          if (activeAnimation) activeAnimation.cancel();
          details.open = opening;
          return;
        }
        var startHeight = details.getBoundingClientRect().height;
        if (activeAnimation) {
          activeAnimation.onfinish = null;
          activeAnimation.oncancel = null;
          activeAnimation.cancel();
        }
        if (opening) details.open = true;
        var endHeight = opening ? details.scrollHeight : summary.getBoundingClientRect().height;
        details.classList.toggle('is-opening', opening);
        details.classList.toggle('is-closing', !opening);
        details.style.overflow = 'hidden';
        var animation = details.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: 250, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        details._apellaAccordionAnimation = animation;
        animation.onfinish = function () {
          if (!opening) details.open = false;
          details.classList.remove('is-opening');
          details.classList.remove('is-closing');
          details.style.removeProperty('overflow');
          if (details._apellaAccordionAnimation === animation) details._apellaAccordionAnimation = null;
        };
        animation.oncancel = function () {
          if (details._apellaAccordionAnimation !== animation) return;
          details.classList.remove('is-opening');
          details.classList.remove('is-closing');
          details.style.removeProperty('overflow');
          details._apellaAccordionAnimation = null;
        };
      }
      details._apellaSetAccordionOpen = setOpen;
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(details._apellaAccordionAnimation ? details.classList.contains('is-closing') : !details.open);
      });
    });
  }

  function tuneMediaImage(img, priority) {
    img.decoding = 'async';
    if (priority === 'high') {
      img.loading = 'eager';
      try { img.fetchPriority = 'high'; } catch (error) {}
    } else if (img.loading !== 'eager') {
      img.loading = 'lazy';
      try { img.fetchPriority = 'auto'; } catch (error) {}
    }
  }

  function preloadMediaAround(slides, index) {
    var current = slides[index];
    if (current) current.querySelectorAll('img').forEach(function (img) { tuneMediaImage(img, 'high'); });
    [index - 1, index + 1].forEach(function (slideIndex) {
      var slide = slides[slideIndex];
      if (!slide) return;
      slide.querySelectorAll('img').forEach(function (img) { tuneMediaImage(img, 'auto'); });
    });
  }

  function initCurrentMediaModal(scope) {
    if (scope.dataset.apellaModalReady === 'true') return;
    scope.dataset.apellaModalReady = 'true';
    var sectionId = scope.dataset.section;
    var modal = sectionId && document.getElementById('ProductModal-' + sectionId);
    var content = modal && modal.querySelector('[data-apella-lazy-modal-content]');
    if (!modal || !content) return;

    var modalItems = Array.prototype.slice.call(scope.querySelectorAll('.product__media-toggle[data-media-id]')).map(function (toggle) {
      var opener = toggle.closest('.product__modal-opener');
      var image = opener && opener.querySelector('img');
      return image ? { mediaId: String(toggle.getAttribute('data-media-id')), image: image } : null;
    }).filter(Boolean);
    var activeModalIndex = 0;

    function modalIsOpen() {
      return modal.hasAttribute('open') || modal.classList.contains('open') || modal.getAttribute('aria-hidden') === 'false';
    }

    function buildImage(index) {
      if (!modalItems.length) return;
      activeModalIndex = (index + modalItems.length) % modalItems.length;
      var item = modalItems[activeModalIndex];
      var sourceImage = item.image;
      var frame = document.createElement('div');
      frame.className = 'apella-modal-media-frame';
      var img = document.createElement('img');
      img.className = 'global-media-settings global-media-settings--no-shadow active';
      img.dataset.mediaId = item.mediaId;
      img.alt = sourceImage.alt || '';
      img.loading = 'eager';
      img.decoding = 'async';
      img.sizes = '(min-width: 750px) calc(100vw - 22rem), 100vw';
      if (sourceImage.srcset) img.srcset = sourceImage.srcset;
      img.src = sourceImage.currentSrc || sourceImage.src;
      img.width = sourceImage.naturalWidth || sourceImage.width || 1100;
      img.height = sourceImage.naturalHeight || sourceImage.height || 1400;
      frame.appendChild(img);

      var controls = document.createElement('div');
      controls.className = 'apella-modal-media-controls';
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'apella-modal-media-nav apella-modal-media-nav--prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.textContent = '‹';
      var counter = document.createElement('span');
      counter.className = 'apella-modal-media-counter';
      counter.textContent = (activeModalIndex + 1) + ' / ' + modalItems.length;
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'apella-modal-media-nav apella-modal-media-nav--next';
      next.setAttribute('aria-label', 'Next image');
      next.textContent = '›';
      controls.append(prev, counter, next);
      content.replaceChildren(frame, controls);
    }

    content.addEventListener('click', function (event) {
      var next = event.target.closest('.apella-modal-media-nav--next');
      var prev = event.target.closest('.apella-modal-media-nav--prev');
      if (!next && !prev) return;
      event.preventDefault();
      buildImage(activeModalIndex + (next ? 1 : -1));
    });

    document.addEventListener('keydown', function (event) {
      if (!modalIsOpen()) return;
      if (event.key === 'ArrowRight') buildImage(activeModalIndex + 1);
      if (event.key === 'ArrowLeft') buildImage(activeModalIndex - 1);
    });

    scope.addEventListener('click', function (event) {
      var toggle = event.target.closest('.product__media-toggle[data-media-id]');
      if (!toggle) return;
      var mediaId = String(toggle.getAttribute('data-media-id'));
      var index = modalItems.findIndex(function (item) { return item.mediaId === mediaId; });
      buildImage(index >= 0 ? index : 0);
    }, true);
  }
  function initGalleryMotion(scope) {
    var gallery = scope.querySelector('media-gallery');
    if (!gallery || gallery.dataset.apellaMotionReady === 'true') return;
    gallery.dataset.apellaMotionReady = 'true';

    var slider = gallery.querySelector('[id^="Slider-Gallery"]');
    var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails"]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    var reducedMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scrollAnimationFrame;
    var scrollBehaviorBeforeAnimation = null;
    var scrollBehaviorPriorityBeforeAnimation = '';
    var scrollSnapBeforeAnimation = null;
    var scrollSnapPriorityBeforeAnimation = '';
    var thumbnailScrollStyleState = null;
    if (!slides.length) return;

    function setActive(index) {
      if (index < 0 || index >= slides.length) return;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-prev', slideIndex === index - 1);
        slide.classList.toggle('is-next', slideIndex === index + 1);
      });
      preloadMediaAround(slides, index);
    }

    function nearestSlideIndex() {
      if (!slider) return 0;
      var sliderBox = slider.getBoundingClientRect();
      var center = sliderBox.left + sliderBox.width / 2;
      var bestIndex = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var box = slide.getBoundingClientRect();
        var distance = Math.abs((box.left + box.width / 2) - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });
      return bestIndex;
    }

    function centeredSlideLeft(index) {
      if (!slider || !slides[index]) return 0;
      return Math.max(0, slides[index].offsetLeft - ((slider.clientWidth - slides[index].clientWidth) / 2));
    }

    function lockNativeScroll(element) {
      if (!element) return null;
      var state = {
        behavior: element.style.getPropertyValue('scroll-behavior'),
        behaviorPriority: element.style.getPropertyPriority('scroll-behavior'),
        snap: element.style.getPropertyValue('scroll-snap-type'),
        snapPriority: element.style.getPropertyPriority('scroll-snap-type'),
      };
      element.style.setProperty('scroll-behavior', 'auto', 'important');
      element.style.setProperty('scroll-snap-type', 'none', 'important');
      return state;
    }

    function restoreNativeScroll(element, state) {
      if (!element || !state) return;
      if (state.behavior) element.style.setProperty('scroll-behavior', state.behavior, state.behaviorPriority);
      else element.style.removeProperty('scroll-behavior');
      if (state.snap) element.style.setProperty('scroll-snap-type', state.snap, state.snapPriority);
      else element.style.removeProperty('scroll-snap-type');
    }

    function thumbnailScrollDetails(index) {
      if (!thumbnailList || !slides[index]) return null;
      var thumbnail = gallery.querySelector('[data-target="' + slides[index].dataset.mediaId + '"]');
      if (!thumbnail) return null;
      var vertical = window.matchMedia('(min-width: 990px)').matches;
      var position = vertical
        ? thumbnail.offsetTop - ((thumbnailList.clientHeight - thumbnail.clientHeight) / 2)
        : thumbnail.offsetLeft - ((thumbnailList.clientWidth - thumbnail.clientWidth) / 2);
      var maximum = vertical
        ? thumbnailList.scrollHeight - thumbnailList.clientHeight
        : thumbnailList.scrollWidth - thumbnailList.clientWidth;
      return {
        vertical: vertical,
        start: vertical ? thumbnailList.scrollTop : thumbnailList.scrollLeft,
        target: Math.max(0, Math.min(maximum, position)),
      };
    }

    function cancelNavigationScroll() {
      if (scrollAnimationFrame) {
        window.cancelAnimationFrame(scrollAnimationFrame);
        scrollAnimationFrame = null;
      }
      if (scrollBehaviorBeforeAnimation !== null) {
        if (scrollBehaviorBeforeAnimation) {
          slider.style.setProperty('scroll-behavior', scrollBehaviorBeforeAnimation, scrollBehaviorPriorityBeforeAnimation);
        } else {
          slider.style.removeProperty('scroll-behavior');
        }
        scrollBehaviorBeforeAnimation = null;
        scrollBehaviorPriorityBeforeAnimation = '';
      }
      if (scrollSnapBeforeAnimation !== null) {
        if (scrollSnapBeforeAnimation) {
          slider.style.setProperty('scroll-snap-type', scrollSnapBeforeAnimation, scrollSnapPriorityBeforeAnimation);
        } else {
          slider.style.removeProperty('scroll-snap-type');
        }
        scrollSnapBeforeAnimation = null;
        scrollSnapPriorityBeforeAnimation = '';
      }
      if (thumbnailScrollStyleState) {
        restoreNativeScroll(thumbnailList, thumbnailScrollStyleState);
        thumbnailScrollStyleState = null;
      }
    }

    function centerSlide(index, animate) {
      if (!slider || !slides[index]) return;
      var targetLeft = centeredSlideLeft(index);
      var thumbnailScroll = thumbnailScrollDetails(index);
      cancelNavigationScroll();

      if (!animate || reducedMotionMql.matches) {
        var previousScrollBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = targetLeft;
        slider.style.scrollBehavior = previousScrollBehavior;
        if (thumbnailScroll) {
          var thumbnailStyles = lockNativeScroll(thumbnailList);
          if (thumbnailScroll.vertical) thumbnailList.scrollTop = thumbnailScroll.target;
          else thumbnailList.scrollLeft = thumbnailScroll.target;
          restoreNativeScroll(thumbnailList, thumbnailStyles);
        }
        setActive(index);
        return;
      }

      var startLeft = slider.scrollLeft;
      var distance = targetLeft - startLeft;
      var startedAt = performance.now();
      var duration = 550;
      scrollBehaviorBeforeAnimation = slider.style.getPropertyValue('scroll-behavior');
      scrollBehaviorPriorityBeforeAnimation = slider.style.getPropertyPriority('scroll-behavior');
      scrollSnapBeforeAnimation = slider.style.getPropertyValue('scroll-snap-type');
      scrollSnapPriorityBeforeAnimation = slider.style.getPropertyPriority('scroll-snap-type');
      slider.style.setProperty('scroll-behavior', 'auto', 'important');
      slider.style.setProperty('scroll-snap-type', 'none', 'important');
      if (thumbnailScroll) thumbnailScrollStyleState = lockNativeScroll(thumbnailList);

      function step(now) {
        var progress = Math.min(1, (now - startedAt) / duration);
        var eased = Math.sin((progress * Math.PI) / 2);
        slider.scrollLeft = startLeft + distance * eased;
        if (thumbnailScroll) {
          var thumbnailPosition = thumbnailScroll.start + (thumbnailScroll.target - thumbnailScroll.start) * eased;
          if (thumbnailScroll.vertical) thumbnailList.scrollTop = thumbnailPosition;
          else thumbnailList.scrollLeft = thumbnailPosition;
        }

        if (progress < 1) {
          scrollAnimationFrame = window.requestAnimationFrame(step);
          return;
        }

        scrollAnimationFrame = null;
        slider.scrollLeft = targetLeft;
        cancelNavigationScroll();
        setActive(index);
      }

      scrollAnimationFrame = window.requestAnimationFrame(step);
    }

    function targetIndexFromButton(button, direction) {
      var targetItem = button.closest('[data-target]');
      var target = button.getAttribute('data-target') || (targetItem && targetItem.getAttribute('data-target'));
      if (target) {
        var targetIndex = slides.findIndex(function (slide) { return slide.dataset.mediaId === target; });
        if (targetIndex >= 0) return targetIndex;
      }
      return Math.max(0, Math.min(slides.length - 1, nearestSlideIndex() + direction));
    }

    function setThumbnailSelection(index) {
      var target = slides[index] && slides[index].dataset.mediaId;
      if (!target) return;
      gallery.querySelectorAll('.thumbnail').forEach(function (thumbnailButton) {
        var thumbnailItem = thumbnailButton.closest('[data-target]');
        if (thumbnailItem && thumbnailItem.dataset.target === target) {
          thumbnailButton.setAttribute('aria-current', 'true');
        } else {
          thumbnailButton.removeAttribute('aria-current');
        }
      });
    }

    var frame;
    function syncActive() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () { setActive(nearestSlideIndex()); });
    }

    setActive(0);

    function bindGalleryInteractions() {
      if (gallery.dataset.apellaMotionBound === 'true') return;
      gallery.dataset.apellaMotionBound = 'true';
      if (slider) {
        slider.addEventListener('scroll', syncActive, { passive: true });
        if ('onscrollend' in window) slider.addEventListener('scrollend', syncActive);
        slider.addEventListener('pointerdown', cancelNavigationScroll, { passive: true });
        slider.addEventListener('touchstart', cancelNavigationScroll, { passive: true });
        slider.addEventListener('wheel', cancelNavigationScroll, { passive: true });
      }

      gallery.querySelectorAll('[id^="GalleryViewer"] > .slider-buttons .slider-button').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          var direction = button.name === 'previous' ? -1 : 1;
          var targetIndex = targetIndexFromButton(button, direction);
          preloadMediaAround(slides, targetIndex);
          setThumbnailSelection(targetIndex);
          gallery.classList.remove('is-nav-animating', 'is-nav-next', 'is-nav-prev');
          void gallery.offsetWidth;
          gallery.classList.add('is-nav-animating', direction < 0 ? 'is-nav-prev' : 'is-nav-next');
          centerSlide(targetIndex, true);
          window.setTimeout(function () {
            gallery.classList.remove('is-nav-animating', 'is-nav-next', 'is-nav-prev');
          }, 780);
        }, true);
      });

      gallery.querySelectorAll('.thumbnail').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          gallery.classList.remove('is-nav-animating', 'is-nav-next', 'is-nav-prev');
          void gallery.offsetWidth;
          var currentIndex = nearestSlideIndex();
          var direction = 1;
          var targetIndex = targetIndexFromButton(button, direction);
          direction = targetIndex < currentIndex ? -1 : 1;
          preloadMediaAround(slides, targetIndex);
          setThumbnailSelection(targetIndex);
          gallery.classList.add('is-nav-animating', direction < 0 ? 'is-nav-prev' : 'is-nav-next');
          centerSlide(targetIndex, true);
          window.setTimeout(syncActive, 140);
          window.setTimeout(syncActive, 360);
          window.setTimeout(function () { gallery.classList.remove('is-nav-animating', 'is-nav-next', 'is-nav-prev'); }, 760);
        });
      });

      if ('ResizeObserver' in window && slider) new ResizeObserver(syncActive).observe(slider);
      window.addEventListener('resize', syncActive, { passive: true });
    }

    if ('requestIdleCallback' in window) window.requestIdleCallback(bindGalleryInteractions, { timeout: 900 });
    else window.setTimeout(bindGalleryInteractions, 180);
  }

  function init() {
    document.querySelectorAll('product-info.apella-pdp').forEach(function (scope) {
      initRequiredVariants(scope);
      initStickyAtc(scope);
      initGalleryMotion(scope);
      initCurrentMediaModal(scope);
      initDetailAccordions(scope);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();









